<div class="card mt-4">
    <p-breadcrumb [model]="breadcrumbItems" [home]="breadcrumbTraitement"></p-breadcrumb>
</div>
<div class="card mt-4">


    <div class="font-semibold text-xl mb-4">Liste des traitements - {{this.nomDo}} - {{this.DO}}</div>
    <p-toolbar styleClass="mb-6">
        <ng-template #start>
            <!-- <p-button label="Ajouter" icon="pi pi-plus" severity="primary" class="mr-2"  /> -->
            <!-- <p-button severity="secondary" label="Supprimer" icon="pi pi-trash" outlined
                [style]="{'color': 'var(--primary-color)'}"
                [disabled]="!selectedTraitements || !selectedTraitements.length "/> -->
            <!-- <p-button severity="secondary" label="Activer" icon="pi pi-check" outlined
                [style]="{'color': 'var(--primary-color)'}" [disabled]="!selectedtraitements || !selectedtraitements.length "
                 /> -->

        </ng-template>

        <ng-template #end>
            <!-- <p-button label="Importer en masse" icon="pi pi-upload" styleClass="p-button-primary" class="mr-2"
                /> -->

            <p-button (click)="ExporterTraitementsCSV()" label="Exporter en CSV" icon="pi pi-download" severity="secondary"
                [disabled]="loading || !traitements || traitements.length === 0" ></p-button>
        </ng-template>
    </p-toolbar>
    <p-table #dt1 [value]="traitements" dataKey="code_interne" [rows]="10" [rowHover]="true" [showGridlines]="true"
        [paginator]="true" [tableStyle]="{ 'min-width': '75rem' }" [(selection)]="selectedTraitements"
        currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} traitements"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="rowsPerPageOptions" exportFilename="traitements_export"
        [loading]="loading" [globalFilterFields]="[
            'IdCallKey',
            'Code_Dossier',
  'Libelle_Interaction',
  'Agent',
  'Moment'
]" responsiveLayout="scroll">
        <ng-template #caption>
            <div class="flex justify-between items-center flex-column sm:flex-row">
                <button pButton label="Réintialiser" class="p-button-outlined mb-2" icon="pi pi-filter-slash"
                    (click)="clear(dt1)"></button>
                <p-iconfield iconPosition="left" class="ml-auto">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                    <input pInputText type="text" (input)="onGlobalFilter(dt1, $event)" placeholder="Rechercher" />
                </p-iconfield>
            </div>
        </ng-template>
        <ng-template #header>
            <tr>
                <th style="width: 2rem; font-weight: bold !important; text-align: center; vertical-align: middle;">
                    <p-tableHeaderCheckbox />
                </th>
                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
    <div class="flex justify-between items-center">
        <span style="font-weight: bold;">ID Interaction</span>
        <p-columnFilter type="text" field="Libelle_Interaction" display="menu" placeholder="Filtrer par Type" />
    </div>
</th>
                <th
                    style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center; white-space: nowrap;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Code Dossier</span>
                        <p-columnFilter type="text" field="code_Dossier" display="menu"
                            placeholder="Rechercher par Code Dossier" />
                    </div>
                </th>



                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;"> Type Interaction</span>
                        <p-columnFilter type="text" field="Libelle_Interaction" display="menu"
                            placeholder="Rechercher par Type Interaction " />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;">Agent </span>
                        <p-columnFilter type="text" field="Agent" display="menu" placeholder="Rechercher par Agent" />
                    </div>
                </th>

                <th style="width: max-content; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-between items-center">
                        <span style="font-weight: bold;"> Date</span>
                        <p-columnFilter type="text" field="Moment" display="menu"
                            placeholder="Rechercher par Date" />
                    </div>
                </th>

                <th style="width: 6rem; padding: 0.5rem; font-weight: bold !important; text-align: center;">
                    <div class="flex justify-center items-center">
                        <span style="font-weight: bold;">Actions</span>
                    </div>
                </th>
            </tr>

        </ng-template>

        <ng-template #body let-traitement>
            <tr>
                <td style="text-align: center; vertical-align: middle;">
                    <p-tableCheckbox [value]="traitement" />
                </td>
               <td style="padding: 0.5rem; white-space: nowrap;">
    <ng-container *ngIf="traitement.Libelle_Interaction === 'Email émis'; else callId">
        {{ traitement.IdEmail }}
    </ng-container>
    <ng-template #callId>
        {{ traitement.IdCallKey }}
    </ng-template>
</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ traitement.code_Dossier }}</td>
                <td style="padding: 0.5rem; white-space: nowrap;">{{ traitement.Libelle_Interaction }}</td>

                <td style="padding: 0.5rem; white-space: nowrap;">{{ traitement.Agent }}
                </td>

                <td style="padding: 0.5rem; white-space: nowrap;">{{ traitement.Moment | date:'dd/MM/yyyy HH:mm' }}
                </td>




                <td class="text-center" style="padding: 0.5rem; vertical-align: middle;">
                    <div class="flex justify-center items-center gap-2">

                        <p-button icon="pi pi-eye" class="mr-1" [rounded]="true" [outlined]="true" (click)="openDetailsTraitement(traitement)"/>
                        <!-- <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true"></p-button>
                        <p-button icon="pi pi-trash" severity="danger" [rounded]="true" [outlined]="true" ></p-button> -->
                    </div>
                </td>
            </tr>

        </ng-template>
        <ng-template #emptymessage>
            <tr>
                <td colspan="8">Aucun traitement trouvé.</td>
            </tr>
        </ng-template>
        <ng-template #loadingbody>
            <tr>
                <td colspan="8">Chargement des données traitements. Veuillez patienter.</td>
            </tr>
        </ng-template>
    </p-table>

    <p-dialog [(visible)]="DetailsDialog" [style]="{ width: '100%', maxWidth: '1000px' }" header="Détails du Traitement" [modal]="true">
  <ng-template #content>
    <div class="flex flex-col gap-6">

      <!-- Ligne 1 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Code Interne</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_interne" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Code DO</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_DO" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 2 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Agent</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.Agent" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">ID CallKey</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.IdCallKey" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 3 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Libellé Interaction</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.Libelle_Interaction" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Libellé Résultat</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.Libelle_Resultat" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 4 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Code Statut</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_Statut" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Étape Suivante</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_EtapeSuiv" class="w-full" readonly />
        </div>
      </div>

      <!-- Infos 1 à 10 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4" >
        <div >
          <label class="block font-bold mb-2">Info{{ 1 }}</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem['Info' + 1]" class="w-full" readonly />
        </div>
         <div >
          <label class="block font-bold mb-2">Info{{ 10 }}</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem['Info' + 10]" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 5 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Flag Info Client</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.FlagInfoClient" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Code Dossier</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_Dossier" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 6 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Code Statut Initial</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_Statut_Initial" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Code Statut Post-Traitement</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_Statut_PostTrait" class="w-full" readonly />
        </div>
      </div>

      <!-- Ligne 7 -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Code Statut Transmission</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.code_Statut_Trans" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Code Tarif</label>
          <input type="text" pInputText [(ngModel)]="selectedTraitementItem.Code_Tarif" class="w-full" readonly />
        </div>
      </div>

      <!-- Dates -->
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label class="block font-bold mb-2">Date de Création</label>
          <input type="text" pInputText [value]="selectedTraitementItem.Moment | date:'short'" class="w-full" readonly />
        </div>
        <div>
          <label class="block font-bold mb-2">Date Insertion</label>
          <input type="text" pInputText [value]="selectedTraitementItem.InsertDateTime | date:'short'" class="w-full" readonly />
        </div>
      </div>

    </div>
  </ng-template>

  <ng-template #footer>
    <p-button label="Fermer" icon="pi pi-times" text (click)="DetailsDialog = false" />
  </ng-template>
</p-dialog>


    <p-confirmdialog [style]="{ width: '450px' }" />

</div>

<p-toast />
